import { SupplierInput } from '@/types/supplier';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function supplier(axios: any) {
  async function getSuppliers(filter: any) {
    try {
      const response = await axios.get(`/api/suppliers?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/suppliers] getSuppliers Error', e);
    }
    return null;
  }

  async function getSupplier(id: number) {
    try {
      const response = await axios.get(`/api/suppliers/${id}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/suppliers] getMaterials Error', e);
    }
    return 0;
  }

  async function createSupplier(payload: SupplierInput) {
    const response = await axios.post('/api/suppliers', camelObjectToSnakeObject(payload, ['taxId']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/suppliers] createSupplier Error', e);
    }
    return null;
  }

  async function updateSupplier(id: number, payload: SupplierInput) {
    const response = await axios.put(`/api/suppliers/${id}`, camelObjectToSnakeObject(payload, ['taxId']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/suppliers] updateSupplier Error', e);
    }
    return null;
  }

  async function deleteSupplier(id: number) {
    const response = await axios.delete(`/api/suppliers/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/suppliers] deleteSupplier Error', e);
    }
    return null;
  }

  async function checkExistingSupplierCode(code: string) {
    const response = await axios.get(`/api/suppliers/check/${code}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/suppliers] checkExistingSupplierCode Error', e);
    }
    return {
      exist: false,
      code: '',
    };
  }

  return {
    getSuppliers,
    getSupplier,
    createSupplier,
    updateSupplier,
    deleteSupplier,
    checkExistingSupplierCode,
  };
}
